import React from "react"
import ReactDOM from "react-dom/client"
import { Provider } from "react-redux"
import { store } from "./app/store"
import App from "./App"
import "./index.css"
import { I18nextProvider } from 'react-i18next'
import i18n from "./common/i18n"
import { NotificationsProvider } from "./features/common/notification/NotificationContext"

ReactDOM.createRoot(document.getElementById("root")!).render(
  <Provider store={store}>
    <I18nextProvider i18n={i18n}>
      <NotificationsProvider>
        <App />
      </NotificationsProvider>
    </I18nextProvider>

  </Provider>
)
